import { Button, Typography } from '@musinsa/mds';
import { CampaignInfo } from './CampaignInfo';

interface ShippingInfoSectionProps {
  /** 수령인 이름 */
  name: string;
  /** 주소 */
  address: string;
  /** 연락처 */
  phone: string;
  /** 배송지 변경 버튼 표시 여부 */
  showChangeButton?: boolean;
  /** 배송지 변경 클릭 핸들러 */
  onChangeAddress?: () => void;
  /** 등록된 배송지 존재 여부. false 면 미설정 안내 노출 (기본 true) */
  registered?: boolean;
  /** 미설정 안내 보조 문구 (서비스별 상이 — 무신사/29CM) */
  emptyDescription?: string;
}

/** 배송지 정보 섹션 — 타이틀/외곽 여백은 CampaignInfo(Container pt-12·gap-y-16·px-16) 표준 사용. */
export const ShippingInfoSection = ({
  name,
  address,
  phone,
  showChangeButton = false,
  onChangeAddress,
  registered = true,
  emptyDescription,
}: ShippingInfoSectionProps) => (
  <CampaignInfo.Container>
    {/* 타이틀 행 — CampaignInfo.Title + 우측 "배송지 변경" 버튼 */}
    <div className="flex items-center justify-between">
      <CampaignInfo.Title>배송지 정보</CampaignInfo.Title>
      {showChangeButton && (
        <Typography size="13" weight="medium" asChild>
          <Button variant="tertiaryOutlinedGray" size={24} onClick={onChangeAddress}>
            배송지 변경
          </Button>
        </Typography>
      )}
    </div>
    {registered ? (
      // row 간 간격은 gap-8px 로 일원화 (이전 row 별 py-4px → 상하 4px 군더더기 제거).
      <div className="flex flex-col gap-[8px]!">
        <Typography variant="body14pxMed" colorScheme="black">
          {name}
        </Typography>
        <Typography variant="body13pxReg" colorScheme="black">
          {address}
        </Typography>
        <Typography variant="body13pxReg" colorScheme="black">
          {phone}
        </Typography>
      </div>
    ) : (
      <div className="flex flex-col items-center gap-[4px]! py-[40px]!">
        <Typography variant="body14pxMed" colorScheme="black">
          등록한 배송지가 없습니다.
        </Typography>
        {emptyDescription && (
          <Typography variant="body13pxReg" colorScheme="gray-500">
            {emptyDescription}
          </Typography>
        )}
      </div>
    )}
  </CampaignInfo.Container>
);
